module.exports = __webpack_public_path__ + "img/kg.9432131d.png";